import React, { useCallback, useEffect, useState } from 'react';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { setNewPassword } from '../../slices/authSlice';

import { useLocation, useNavigate } from 'react-router-dom';
import { showPromiseNotification } from '../../common/notification';
import { Loading } from '../../components/loading/loading';
import { useTranslation } from 'react-i18next';
import '../../i18'; 

const SetupNewPassword = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const state = location.state;
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        if (!state || !state?.id) {
            navigate("/sign-in");
        }
        setIsLoading(false);
    },
        [state, navigate]
    )

    // Dynamically change validation schema based on active tab
    const passwordSchema = Yup.object().shape({
        new_password: Yup.string()
            .trim()
            .required(t("required", {field : t("new_password")}))
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                t('passwordValidation')
            ),
        confirm_password: Yup.string()
            .trim()
            .required(t("required", {field : t("confirm_password")}))
            .oneOf([Yup.ref('new_password'), null], t('matchPassword'))
    });

    const formOptions = { resolver: yupResolver(passwordSchema) };
    const { register, handleSubmit, formState } = useForm(formOptions);
    const { errors } = formState;

    const onSubmit = useCallback(
        async (values) => {
            values.id = state?.id;

            const myPromise = new Promise((resolve, reject) => {
                dispatch(
                    setNewPassword({
                        payload: {
                            ...values,
                        },
                    })
                )
                    .then((response) => {
                        if (response.payload.code === 200) {
                            resolve(response.payload)
                            navigate("/home")
                        }
                        else {
                            reject(response.payload)
                        }
                    });
            });

            showPromiseNotification(myPromise);
        },
        [dispatch, navigate, state?.id]
    );

    if (isLoading) {
        return (
            <Loading />
        )
    }

    return (
        <div className="signin-page-area">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-7">
                        <form className="signin-inner" onSubmit={handleSubmit(onSubmit)}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="single-input-inner style-bg-border">
                                        <h4 className="SignInUpHeading">
                                            {t('setNewPasswordHeading')}
                                        </h4>
                                        <p className="ForgotText">
                                            {t('addNewPasswordHeading')}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="single-input-inner style-bg-border position-relative">
                                        <input name="new_password" type={showPassword ? "text" : "password"} id="new_password" placeholder={t("enterFieldName", { field: t("New_Password")})} autocomplete="off" {...register('new_password')} />
                                        <span className="EyeLink" id="togglePassword" onClick={() => setShowPassword(prev => !prev)} style={{ cursor: "pointer" }}>
                                            <img
                                                src={showPassword ? process.env.PUBLIC_URL + '/assets/img/icon/open-eye.svg' : process.env.PUBLIC_URL + '/assets/img/icon/close-eye.svg'}
                                                alt={showPassword ? "Close-eye" : "Open-eye"}
                                                className={`Eyeicon ${showPassword ? "Eyeicon CloseEye" : "Eyeicon OpenEye"}`}
                                            />
                                        </span>
                                        <p className="text-danger">
                                            {errors.new_password?.message}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="single-input-inner style-bg-border position-relative">
                                        <input name="confirm_password" type={showConfirmPassword ? "text" : "password"} id="confirm_password" className="form-control" placeholder={t("enterFieldName", { field: t("Confirm_New_Password")})} autocomplete="off" {...register('confirm_password')} />
                                        <span className="EyeLink" id="CreatetogglePassword" onClick={() => setShowConfirmPassword(prev => !prev)} style={{ cursor: "pointer" }}>
                                            <img
                                                src={showConfirmPassword ? process.env.PUBLIC_URL + '/assets/img/icon/open-eye.svg' : process.env.PUBLIC_URL + '/assets/img/icon/close-eye.svg'}
                                                alt={showConfirmPassword ? "Close-eye" : "Open-eye"}
                                                className={`Eyeicon ${showPassword ? "Eyeicon CloseEye" : "Eyeicon OpenEye"}`}
                                            />
                                        </span>
                                        <p className="text-danger">
                                            {errors.confirm_password?.message}
                                        </p>
                                    </div>
                                </div>
                                <div className="col-12 mb-4">
                                    <button type='submit' className="btn btn-base w-100">
                                        {t('resetPassword')}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SetupNewPassword;